import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import React from "react";
import FlightOptionsContext from "../Session/flightOptionsContext";

const EventTypeSelector = (props) => {
    const {value, disabled, onChange, sortieEvents} = props;
    const flightOptions = React.useContext(FlightOptionsContext);
    const events = sortieEvents || flightOptions.sortieEvents;

    if (!events) {
        return null;
    }

    return (
        <>
            <FormControl style={{minWidth: 100}} disabled={disabled}>
                <InputLabel htmlFor="event-type-select">
                    Event Type
                </InputLabel>
                <Select
                    id="event-type-select"
                    value={value}
                    onChange={(event) => onChange(event.target.value)}
                >
                    {Object.keys(events).map((keyName, keyIndex) =>
                        <MenuItem value={keyName} key={keyIndex} >
                            {events[keyName].name}
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
        </>
    );
}

export default EventTypeSelector;